<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-anti-porn`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.657 2.829l39.598 39.597a1 1 0 010 1.415l-1.414 1.414a1 1 0 01-1.415 0L2.828 5.657a1 1 0 010-1.414l1.415-1.414a1 1 0 011.414 0zM4.929 12l4 4H6v2.228c8.215.963 14.78 7.786 15.848 16.407l.042.365h4.22a19.93 19.93 0 01.232-1.587l3.437 3.437V38a1 1 0 01-.883.993l-.117.007H19.25a1 1 0 01-.993-.883L18.25 38v-1.077c0-7.912-6.363-14.703-13.95-14.878L4 22.042H3a1 1 0 01-.993-.884L2 21.042V13a1 1 0 01.883-.993L3 12h1.929zM45 12H19.071l4 4H42v2.228l-.428.055c-4.118.589-7.799 2.654-10.546 5.671l2.753 2.754c2.606-2.852 6.253-4.666 10.221-4.666h1l.117-.007a1 1 0 00.883-.993V13l-.007-.117A1 1 0 0045 12z"/></svg>
</template>
<script>

export default {
  name: 'IconAntiPorn',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
